import { TDashboardComponent } from "MyDashboards/components/ComponentRegistry/types";
import { Element } from "MyDashboards/state/editorTypes";
import px from "MyDashboards/utils/px";
import HighChart from "MyDashboards/views/ChartsTesting/HighChart";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import React from "react";

/**
 * This component renders a placeholder box in place of the actual element, can be used as default renderer
 */
const Highchart: TDashboardComponent = {
  editorMode: "none",
  Edit: () => (
    <div style={{ padding: "20px" }}>
      Highchart test component, editor has not been implemented yet
    </div>
  ),
  Render: ({ el }: { el: Element }) => {
    const ctx = useAppContext();
    if (!el.component) {
      return null;
    }
    return (
      <div
        key={`chart_${el.id}`}
        style={{
          width: px(el.component.width),
          height: px(el.component.height),
          transform: `scale(${el.width / el.component.width})`,
          transformOrigin: ctx.rtl ? "top right" : "top left",
        }}
      >
        <HighChart
          options={{
            ...el.component.data,
            width: el.component.width,
            height: el.component.width * (el.height / el.width),
          }}
        />
      </div>
    );
  },
};
export default Highchart;
